import React from 'react';
import { Control, Controller } from 'react-hook-form';
import {
  Checkbox as MuiCheckbox,
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormHelperText
} from '@mui/material';
import { useTextStyles } from '../../../theme/text';

export interface CheckboxProps {
  control: Control;
  name: string;
  label: string;
  labelPlacement?: FormControlLabelProps['labelPlacement'];
  helperText?: string;
  disabled?: boolean;
  required?: string | boolean;
  defaultValue?: boolean;
  style?: React.CSSProperties;
}

export const Checkbox = ({
  control,
  name,
  label,
  labelPlacement,
  helperText,
  style,
  disabled = false,
  required = false,
  defaultValue = false
}: CheckboxProps) => {
  const textClasses = useTextStyles();

  return (
    <Controller
      name={name}
      control={control}
      rules={{ required }}
      defaultValue={defaultValue}
      render={({ field: { value, ...fieldValues }, fieldState: { error: fieldError } }) => (
        <FormControl error={!!fieldError} component="fieldset" style={style}>
          <FormControlLabel
            label={label}
            labelPlacement={labelPlacement}
            classes={{ label: textClasses.checkboxLabel }}
            control={
              <MuiCheckbox
                checked={value}
                color="primary"
                size="small"
                disabled={disabled}
                required={!!required}
                {...fieldValues}
              />
            }
          />
          {helperText && !fieldError && <FormHelperText>{helperText}</FormHelperText>}
          {fieldError && <FormHelperText>{fieldError.message}</FormHelperText>}
        </FormControl>
      )}
    />
  );
};
